import React from 'react';
import loadable from '@loadable/component';
import { Loading } from 'components';
import { ROUTES_PATH_FORGOT_PASSWORD } from 'routes';

const ForgotPassword = loadable(() => import('./components'), {
	fallback: <Loading size={50} />,
});

export const ForgotPasswordRoutes = [
	{
		path: ROUTES_PATH_FORGOT_PASSWORD,
		component: ForgotPassword,
		isPublic: true,
	},
];

export default ForgotPasswordRoutes;
